import React from "react"
import styled, { css } from "styled-components"
import MDX from "@mdx-js/runtime"

import { H2, H3, H4, Paragraph } from "components/text"
import { FontConfigurations, UNDERLINE_TEXT_CSS } from "theme"

const ParagraphContainer = styled(Paragraph)`
  & strong {
    font-weight: 700;
  }
`

const LI = styled.li`
  padding-inline-start: ${props => props.theme.space[3]};
  font-family: ${props => props.theme.fonts.paragraph};
  line-height: ${FontConfigurations.p.lineHeight};
  list-style-type: initial;
`

const listCSS = css`
  font-family: ${props => props.theme.fonts.paragraph};
  line-height: ${FontConfigurations.pLg.lineHeight};
  margin-bottom: ${props => props.theme.space[5]};
  margin-left: ${props => props.theme.space[5]};
  font-size: ${FontConfigurations.pLg.fontSize};
  padding: 0;
`

const UL = styled.ul`
  ${listCSS}
  ${LI} {
    list-style-type: initial;
  }
`

const OL = styled.ol`
  ${listCSS}
  ${LI} {
    list-style-type: decimal;
  }
`

const A = styled.a.attrs({
  target: "_blank"
})`
  font-family: ${props => props.theme.fonts.paragraph};
  line-height: ${FontConfigurations.pLg.lineHeight};
  color: ${props => props.theme.colors.astralBlue};
  font-weight: 700;
  text-decoration: none;

  &:hover {
    ${UNDERLINE_TEXT_CSS}
  }
`

type MarkdownProps = {
  content: string
}

const components = {
  // set H - 1 here because it look too big
  h1: (props: HTMLHeadingElement) => <H2 mt={7} mb={6} {...props} />,
  h2: (props: HTMLHeadingElement) => <H3 mt={7} mb={5} {...props} />,
  h3: (props: HTMLHeadingElement) => <H4 mt={7} mb={4} {...props} />,
  p: (props: HTMLParagraphElement) => <ParagraphContainer mb={5} {...props} />,
  ul: UL,
  ol: OL,
  a: A,
  li: LI
}

export const Markdown: React.FC<MarkdownProps> = ({ content }) => <MDX components={components}>{content}</MDX>
